var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.064 11.477.94 9.807S.326 9.56.524 8.995c.04-.116.122-.215.367-.385C2.027 7.82 21.911.672 21.911.672s.561-.19.892-.063a.484.484 0 0 1 .33.36c.036.147.05.3.045.452-.002.131-.018.253-.03.445-.121 1.954-3.745 16.537-3.745 16.537s-.217.853-.994.882a1.423 1.423 0 0 1-1.037-.4c-1.524-1.312-6.793-4.853-7.958-5.632a.223.223 0 0 1-.095-.158c-.017-.082.073-.183.073-.183S18.567 4.756 18.81 3.9c.019-.066-.053-.099-.149-.07-.609.224-11.173 6.895-12.339 7.632a.562.562 0 0 1-.259.015z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgwhite);
export default __webpack_public_path__ + "static/media/tgwhite.9c5fd19512c103b7282a2f37ff5dfb45.svg";
export { ForwardRef as ReactComponent };